<div class="d-flex flex-column" style="padding: 15px">
    @if (candidatesAccepted.length) {
      <div>
        <div class="py-px-24">
          <app-text-separator text="Acceptée"></app-text-separator>
        </div>

        @for (item of candidatesAccepted; track $index) {
          <div class="card-container p-px-16 mb-px-24">
            <div class="w-fit-content pb-px-16">
              <app-tag [label]="candidatStatusLabelsMap[item.statusOfCandidatOnMission] || item.statusOfCandidatOnMission" [type]="1" customIcon="check-success"></app-tag>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex flex-column">
                <app-user [text]="item.candidateName" [imageSrc]="item.candidatePhoto"></app-user>
              </div>
            <div class="d-flex align-items-center">
              <span class="chat-icon-wrapper" *ngIf="isChatActive" matTooltip="Envoyer un message au candidat" (click)="openMessageDialog(item, $event)">
                <mat-icon class="chat-icon">chat_bubble</mat-icon>
              </span>
              <app-button text="Voir Candidat" [stroked]="true" color="primary" class="me-1"
                          (handleClick)="openDetailCandidate(item.candidatId)"></app-button>
              @if (canCancelCandidacy(item)) {
              <app-button text="Annuler la candidature" [stroked]="true" color="warn" class="me-1" [disabled]="loading"
                          (handleClick)="cancelCandidacy(item)"></app-button>
              }
            </div>
            </div>
          </div>
        }
      </div>
    }

    @if (candidatesCanceledByAgency.length) {
      <div>
        <div class="py-px-24">
          <app-text-separator text="Annulée par Collary" textClass="w-px-300"></app-text-separator>
        </div>
        @for (item of candidatesCanceledByAgency; track $index) {
          <div class="card-container p-px-16 mb-px-24">
            <div class="w-fit-content pb-px-16">
              <app-tag label="Annulée par Collary" [type]="3"></app-tag>
            </div>
            <div class="d-flex justify-content-between align-items-center">
              <app-user [text]="item.candidateName" [imageSrc]="item.candidatePhoto"></app-user>
              <app-button text="Voir Candidat" [stroked]="true" color="primary" class="me-1"
                          (handleClick)="openDetailCandidate(item.candidatId)"></app-button>
            </div>
          </div>
        }
      </div>
    }

    @if (availableCandidates.length > 0) {
      <div class="py-px-24">
        <app-text-separator text="Toutes les candidats disponibles" textClass="w-px-300"></app-text-separator>
      </div>

      @for (item of availableCandidates; track $index) {
        <div class="card-container p-px-16 mb-px-24">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column">
              <app-user [text]="item.candidateName" [imageSrc]="item.candidatePhoto"></app-user>
            </div>
            <div class="d-flex align-items-center">
              @if (!isMissionCanceled && mayAssign) {
              <app-button text="Affecter mission" [stroked]="true" color="primary" class="me-1"
              (handleClick)="affectMissionToCandidate(item.candidatId, missionId)"></app-button>
              }
            </div>
          </div>
        </div>
      }
    }

    @if (candidatesNotAccepted.length) {
      <div class="py-px-24">
        <app-text-separator text="Toutes les candidatures" textClass="w-px-300"></app-text-separator>
      </div>

      @for (item of candidatesNotAccepted; track $index) {
        <div class="card-container p-px-16 mb-px-24">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-column">
              <app-user [text]="item.candidateName" [imageSrc]="item.candidatePhoto"></app-user>
            </div>
            <div class="d-flex align-items-center">
              <app-button text="Voir profil" [stroked]="true" color="primary" class="me-1"
                          (handleClick)="openDetailCandidate(item.candidatId)"></app-button>
              @if (canCancelCandidacy(item)) {
              <app-button text="Annuler la candidature" [stroked]="true" color="warn" class="me-1" [disabled]="loading"
                          (handleClick)="cancelCandidacy(item)"></app-button>
              }

              @if (!isMissionCanceled) {
              @if(item.statusOfCandidatOnMission == CandidatStatusOnMission.CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT) {
                <app-button text="Accepter la demande d'annulation" [disabled]="candidatesAccepted.length > 0 || loading" [loading]="loading"
                            (handleClick)="acceptCancelRequest(item)" srcIcon="/assets/icons/double-checks-white.svg"></app-button>
              } @else if (mayRespond) {
                <app-button text="Accepter" [disabled]="expired || candidatesAccepted.length > 0 || loading" [loading]="loading"
                            (handleClick)="updateApplicationStatus(item)" srcIcon="/assets/icons/double-checks-white.svg"></app-button>
              }
              }
              <span class="chat-icon-wrapper" *ngIf="isChatActive" matTooltip="Envoyer un message au candidat" (click)="openMessageDialog(item, $event)">
                <mat-icon class="chat-icon">chat_bubble</mat-icon>
              </span>
            </div>
          </div>
        </div>
      }
    }
  </div>
@if(!candidatesAccepted.length && !availableCandidates.length && !candidatesNotAccepted.length) {
  <div class="d-flex flex-column no-condidat" style="padding: 15px">
    <svg-icon src="/assets/icons/search-file.svg"></svg-icon>
    <div class="d-flex flex-column">
      <span class="fs-20 fw-4">Aucun candidat pour l'instant</span>
      <span class="text-secondary fs-16 fw-4">Les candidatures pour cette mission seront affichées ici. Vous pourrez
        sélectionner et accepter un candidat parmi la liste.</span>
    </div>
  </div>
}
